import { HOUR_IN_SECONDS } from '@v2/pages/common/constants/base.constants';

export const computeRightLegend = (maxValue: number, isDay: boolean): number[] => {
  const hours = Math.ceil(maxValue / HOUR_IN_SECONDS);
  if (hours <= 1 && isDay) return [0, 0.5, 1];
  if (hours <= 2) return [0, 1, 2];
  if (hours <= 4) return [0, 2, 4];
  if (hours <= 6) return [0, 3, 6];
  if (hours <= 12) return [0, 6, 12];
  if (hours <= 18) return [0, 9, 18];
  if (hours <= 24) return [0, 12, 24];
  return [0, Math.round(hours / 2), hours];
};
